import React, { Component } from "react";
import { Link } from "react-router-dom";
import {
  Row,
  Col,
  Card,
  Icon,
  DatePicker,
  Input,
  Table,
  Select,
  Button,
  Tag,
  Radio,
  Timeline,
  Spin,
  Switch,
} from "antd";
import moment from "moment";
import F from "../../Functions";
import axios from "axios";
import Pagination from "../../components/pagination";
import Stats from "./parts/vonboard/stats";
import { Translate } from "react-translated";
import { API_DATE_FORMAT, debounceQuery } from "../../utils/Constants";

const Option = Select.Option;
const { RangePicker } = DatePicker;
const today = new Date();
const antIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;

class RSOVonboard extends Component {
  state = {
    loading: false,
    period: "from_to",
    start_date: moment(new Date("2010-01-01")).format("YYYY-MM-DD"),
    end_date: moment(new Date("2050-01-01")).format("YYYY-MM-DD"),
    buckets: [
      {
        index: 0,
        title: "My Claimed Calls",
        calls: [],
        loading: false,
        page: 1,
        total_pages: 0,
        filters: {
          search:
            "rso_vo_box1_search" in window.localStorage
              ? window.localStorage.rso_vo_box1_search
              : "",
          agency:
            "rso_vo_box1_agency" in window.localStorage
              ? window.localStorage.rso_vo_box1_agency
              : "",
        },
      },
      {
        index: 1,
        title: "Due Calls",
        calls: [],
        loading: false,
        page: 1,
        total_pages: 0,
        filters: {
          search:
            "rso_vo_box2_search" in window.localStorage
              ? window.localStorage.rso_vo_box2_search
              : "",
          agency:
            "rso_vo_box2_agency" in window.localStorage
              ? window.localStorage.rso_vo_box2_agency
              : "",
        },
      },
      {
        index: 2,
        title: "Active Calls",
        calls: [],
        loading: false,
        page: 1,
        total_pages: 0,
        filters: {
          search:
            "rso_vo_box3_search" in window.localStorage
              ? window.localStorage.rso_vo_box3_search
              : "",
          agency:
            "rso_vo_box3_agency" in window.localStorage
              ? window.localStorage.rso_vo_box3_agency
              : "",
        },
      },
      {
        index: 3,
        title: "Calendar Invites",
        calls: [],
        loading: false,
        page: 1,
        total_pages: 0,
        filters: {
          search:
            "rso_vo_box4_search" in window.localStorage
              ? window.localStorage.rso_vo_box4_search
              : "",
          agency:
            "rso_vo_box4_agency" in window.localStorage
              ? window.localStorage.rso_vo_box4_agency
              : "",
        },
      },
      {
        index: 4,
        title: "Upcoming Calls",
        calls: [],
        loading: false,
        page: 1,
        total_pages: 0,
        filters: {
          search:
            "rso_vo_box5_search" in window.localStorage
              ? window.localStorage.rso_vo_box5_search
              : "",
          agency:
            "rso_vo_box5_agency" in window.localStorage
              ? window.localStorage.rso_vo_box5_agency
              : "",
        },
      },
      {
        index: 5,
        title: "Completed Calls",
        calls: [],
        loading: false,
        page: 1,
        total_pages: 0,
        filters: {
          search:
            "rso_vo_box6_search" in window.localStorage
              ? window.localStorage.rso_vo_box6_search
              : "",
          agency:
            "rso_vo_box6_agency" in window.localStorage
              ? window.localStorage.rso_vo_box6_agency
              : "",
        },
      },
      {
        index: 6,
        title: "Not Reached Archived",
        calls: [],
        loading: false,
        page: 1,
        total_pages: 0,
        filters: {
          search:
            "rso_vo_box7_search" in window.localStorage
              ? window.localStorage.rso_vo_box7_search
              : "",
          agency:
            "rso_vo_box7_agency" in window.localStorage
              ? window.localStorage.rso_vo_box7_agency
              : "",
        },
      },
      {
        index: 7,
        title: "Sent For Financial",
        calls: [],
        loading: false,
        page: 1,
        total_pages: 0,
        filters: {
          search:
            "rso_vo_box8_search" in window.localStorage
              ? window.localStorage.rso_vo_box8_search
              : "",
          agency:
            "rso_vo_box8_agency" in window.localStorage
              ? window.localStorage.rso_vo_box8_agency
              : "",
        },
      },
      {
        index: 8,
        title: "Not Interested",
        calls: [],
        loading: false,
        page: 1,
        total_pages: 0,
        filters: {
          search:
            "rso_vo_box9_search" in window.localStorage
              ? window.localStorage.rso_vo_box9_search
              : "",
          agency:
            "rso_vo_box9_agency" in window.localStorage
              ? window.localStorage.rso_vo_box9_agency
              : "",
        },
      },
    ],
    columns: [
      {
        title: "Name",
        dataIndex: "name",
        key: "name",
      },
      {
        title: "Phone",
        dataIndex: "phone",
        key: "phone",
      },
      {
        title: "Agency",
        dataIndex: "agency",
        key: "agency",
      },
      {
        title: "Type",
        dataIndex: "type",
        key: "type",
      },
      {
        title: "Status",
        dataIndex: "status",
        key: "status",
      },
      {
        title: "Due Date",
        dataIndex: "due_date",
        key: "due_date",
      },
      {
        title: "Call Attempts",
        dataIndex: "call_attempts",
        key: "call_attempts",
      },
      {
        title: "Who Created",
        dataIndex: "who_created",
        key: "who_created",
      },
      {
        title: "Action",
        dataIndex: "action",
        key: "action",
      },
    ],
    user: this.props.auth.user,
    agencies: [],
    stats: {},
    stats_loading: false,
    agency_id: this.props.agency_id,
  };

  call_vo_agancies = () => {
    axios.get("/api/vo_agencies").then((res) => {
      this.setState({
        agencies: res.data,
      });
    });
  }

  componentDidMount = () => {
    this.call_vo_agancies()

    if ("rso_vo_period" in window.localStorage) {
      if (window.localStorage.rso_vo_period === "from_to") {
        this.setState({
          start_date: window.localStorage.rso_vo_start_date,
          end_date: window.localStorage.rso_vo_end_date,
          period: window.localStorage.rso_vo_period,
        });
      } else if (window.localStorage.rso_vo_period === "all_bfiles") {
        this.setState({
          period: window.localStorage.rso_vo_period,
        });
      }
    }
    this.loadBuckets("all", 1);
    this.loadStats();
    this.loadCalendar(3);
  };
  componentDidUpdate() {
    if (this.props.agency_id !== this.state.agency_id) {
      this.setState({ agency_id: this.props.agency_id }, () => {
        this.loadBuckets("all", 1);
        this.loadStats();
        this.loadCalendar(3);
      });
    }
  }
  changePeriod = (e) => {
    const value = e.target.value;
    if (value === "mtd") {
      window.localStorage.rso_vo_start_date = null;
      window.localStorage.rso_vo_end_date = null;
      window.localStorage.rso_vo_period = value;

      this.setState(
        {
          start_date: null,
          end_date: null,
          period: value,
        },
        () => {
          this.loadBuckets("all", 1);
          this.loadStats();
        }
      );
    } else {
      window.localStorage.rso_vo_start_date = new Date("2010-01-01");
      window.localStorage.rso_vo_end_date = new Date(
        today.getFullYear(),
        today.getMonth() + 1,
        1
      );
      window.localStorage.rso_vo_period = value;

      this.setState(
        {
          start_date: new Date("2010-01-01"),
          end_date: new Date(today.getFullYear(), today.getMonth() + 1, 1),
          period: value,
        },
        () => {
          this.loadBuckets("all", 1);
          this.loadStats();
        }
      );
    }
  };
  search = (ind, search) => {
    this.setState((prevState) => {
      const newBuckets = prevState.buckets.map(bucket => {
        if (bucket.index === ind) {
          return {
            ...bucket,
            loading: true,
            filters: {
              ...bucket.filters,
              search: search
            }
          };
        }
        return bucket;
      });
      return { buckets: newBuckets };
    }, () => {
      this.loadBuckets(ind, 1);
    });
  };
  agencyChange = (ind, agency_id) => {
    this.setState((prevState) => {
      const newBuckets = prevState.buckets.map((bucket, i) => {
        if (bucket.index === ind) {
          window.localStorage["rso_vo_box" + (i + 1) + "_agency"] = agency_id;
          return {
            ...bucket,
            loading: true,
            filters: {
              ...bucket.filters,
              agency: agency_id,
              search: ""
            }
          };
        }
        return bucket;
      });
      return { buckets: newBuckets };
    }, () => {
      this.loadBuckets(ind, 1);
    });
  };
  onChangeDateRange = (date, dateString) => {
    window.localStorage.rso_vo_start_date = date[0];
    window.localStorage.rso_vo_end_date = date[1];
    window.localStorage.rso_vo_period = "from_to";

    this.setState(
      {
        start_date: date[0],
        end_date: date[1],
        period: "from_to",
      },
      () => {
        this.loadBuckets("all", 1);
        this.loadStats();
      }
    );
  };
  refresh = () => {
    this.setState({ loading: true });
    axios.get("/api/delete_user_cache").then((res) => {
      this.setState({
        loading: false,
        period: "from_to",
        start_date: moment(new Date("2010-01-01")).format("YYYY-MM-DD"),
        end_date: moment(new Date("2050-01-01")).format("YYYY-MM-DD"),
        buckets: [
          {
            index: 0,
            title: "My Claimed Calls",
            calls: [],
            loading: false,
            page: 1,
            total_pages: 0,
            filters: {
              search:
                "rso_vo_box1_search" in window.localStorage
                  ? window.localStorage.rso_vo_box1_search
                  : "",
              agency:
                "rso_vo_box1_agency" in window.localStorage
                  ? window.localStorage.rso_vo_box1_agency
                  : "",
            },
          },
          {
            index: 1,
            title: "Due Calls",
            calls: [],
            loading: false,
            page: 1,
            total_pages: 0,
            filters: {
              search:
                "rso_vo_box2_search" in window.localStorage
                  ? window.localStorage.rso_vo_box2_search
                  : "",
              agency:
                "rso_vo_box2_agency" in window.localStorage
                  ? window.localStorage.rso_vo_box2_agency
                  : "",
            },
          },
          {
            index: 2,
            title: "Active Calls",
            calls: [],
            loading: false,
            page: 1,
            total_pages: 0,
            filters: {
              search:
                "rso_vo_box3_search" in window.localStorage
                  ? window.localStorage.rso_vo_box3_search
                  : "",
              agency:
                "rso_vo_box3_agency" in window.localStorage
                  ? window.localStorage.rso_vo_box3_agency
                  : "",
            },
          },
          {
            index: 3,
            title: "Calendar Invites",
            calls: [],
            loading: false,
            page: 1,
            total_pages: 0,
            filters: {
              search:
                "rso_vo_box4_search" in window.localStorage
                  ? window.localStorage.rso_vo_box4_search
                  : "",
              agency:
                "rso_vo_box4_agency" in window.localStorage
                  ? window.localStorage.rso_vo_box4_agency
                  : "",
            },
          },
          {
            index: 4,
            title: "Upcoming Calls",
            calls: [],
            loading: false,
            page: 1,
            total_pages: 0,
            filters: {
              search:
                "rso_vo_box5_search" in window.localStorage
                  ? window.localStorage.rso_vo_box5_search
                  : "",
              agency:
                "rso_vo_box5_agency" in window.localStorage
                  ? window.localStorage.rso_vo_box5_agency
                  : "",
            },
          },
          {
            index: 5,
            title: "Completed Calls",
            calls: [],
            loading: false,
            page: 1,
            total_pages: 0,
            filters: {
              search:
                "rso_vo_box6_search" in window.localStorage
                  ? window.localStorage.rso_vo_box6_search
                  : "",
              agency:
                "rso_vo_box6_agency" in window.localStorage
                  ? window.localStorage.rso_vo_box6_agency
                  : "",
            },
          },
          {
            index: 6,
            title: "Not Reached Archived",
            calls: [],
            loading: false,
            page: 1,
            total_pages: 0,
            filters: {
              search:
                "rso_vo_box7_search" in window.localStorage
                  ? window.localStorage.rso_vo_box7_search
                  : "",
              agency:
                "rso_vo_box7_agency" in window.localStorage
                  ? window.localStorage.rso_vo_box7_agency
                  : "",
            },
          },
          {
            index: 7,
            title: "Sent For Financial",
            calls: [],
            loading: false,
            page: 1,
            total_pages: 0,
            filters: {
              search:
                "rso_vo_box8_search" in window.localStorage
                  ? window.localStorage.rso_vo_box8_search
                  : "",
              agency:
                "rso_vo_box8_agency" in window.localStorage
                  ? window.localStorage.rso_vo_box8_agency
                  : "",
            },
          },
          {
            index: 8,
            title: "Not Interested",
            calls: [],
            loading: false,
            page: 1,
            total_pages: 0,
            filters: {
              search:
                "rso_vo_box9_search" in window.localStorage
                  ? window.localStorage.rso_vo_box9_search
                  : "",
              agency:
                "rso_vo_box9_agency" in window.localStorage
                  ? window.localStorage.rso_vo_box9_agency
                  : "",
            },
          },
        ],
      });
      this.call_vo_agancies()
      this.loadBuckets("all", 1);
      this.loadStats();
    });
  };
  loadStats = () => {
    const { agency_id, user, period, start_date, end_date } = this.state;
    const today = new Date();
    let from = new Date(today.getFullYear(), today.getMonth(), 1);
    let to = new Date(today.getFullYear(), today.getMonth() + 1, 1);
    let url = "/api/user_vonboard_stats";

    if (agency_id) {
      url = "/api/user_vonboard_stats?agency_id=" + agency_id;
    }

    this.setState({ stats_loading: true });

    if (period === "from_to") {
      (from = start_date), (to = end_date);
    }

    axios
      .post(url, {
        user: user.id,
        from: moment(from)
          .utc()
          .format("YYYY-MM-DD"),
        to: moment(to)
          .utc()
          .format("YYYY-MM-DD"),
      })
      .then((res) => {
        this.setState({
          stats: res.data,
          stats_loading: false,
        });
      });
  };
  loadBuckets = (sec, page) => {
    const url_filters = "";
    const { user } = this.state;
    const today = moment(new Date()).format("YYYY-MM-DD");

    if (sec === "all" || sec == 0) {
      this.loadBucket(
        0,
        "my_vonboard_bfiles",
        '{"name":"vob_attempted","op":"is_null"},{"name":"vob_completed","op":"is_null"},{"name":"vob_archived","op":"is_null"},{"name":"onboarding_id","op":"==","val":"' +
        user.id +
        '"}',
        page
      );
    }
    if (sec === "all" || sec == 1) {
      this.loadBucket(
        1,
        "b_file",
        '{"name":"vob_archived","op":"is_null"},{"name":"vob_attempted","op":"is_null"},{"name":"vob_attempted","op":"is_null"},{"name":"vob_completed","op":"is_null"},{"or":[{"name":"onboarding_user","op":"is_null"},{"name":"onboarding_user","op":"has","val":{"name":"user_type","op":"!=","val":"VONBOARDER"}}]},{"name":"expiration_date","op":"<=","val":"' +
        `${today} 23:59:59` +
        '"}',
        page
      );
    }
    if (sec === "all" || sec == 2) {
      this.loadBucket(
        2,
        "my_vonboard_bfiles",
        '{"name":"vob_attempted","op":"==","val":1},{"name":"vob_completed","op":"is_null"},{"name":"vob_archived","op":"is_null"},{"name":"onboarding_id","op":"==","val":"' +
        user.id +
        '"}',
        page
      );
    }
    if (sec === "all" || sec == 4) {
      this.loadBucket(
        4,
        "b_file",
        '{"or":[{"name":"onboarding_user","op":"is_null"},{"name":"onboarding_user","op":"has","val":{"name":"user_type","op":"!=","val":"VONBOARDER"}}]},{"name":"expiration_date","op":">=","val":"' +
        `${today} 00:00:00` +
        '"}',
        page
      );
    }
    if (sec === "all" || sec == 5) {
      this.loadBucket(
        5,
        "my_vonboard_bfiles",
        '{"name":"vob_completed","op":"==","val":1},{"name":"vob_archived","op":"is_null"},{"name":"onboarding_id","op":"==","val":"' +
        user.id +
        '"}',
        page
      );
    }
    if (sec === "all" || sec == 6) {
      this.loadBucket(
        6,
        "my_vonboard_bfiles",
        '{"name":"vob_archived","op":"==","val":1},{"name":"vob_attempted","op":"is_null"},{"name":"onboarding_id","op":"==","val":"' +
        user.id +
        '"}',
        page
      );
    }
    if (sec === "all" || sec == 7) {
      this.loadBucket(
        7,
        "my_vonboard_bfiles",
        '{"name":"vob_completed","op":"==","val":1},{"name":"vob_archived","op":"is_null"},{"name":"onboarding_id","op":"==","val":"' +
        user.id +
        '"},{"name":"financial_id","op":"is_not_null"}',
        page
      );
    }
    if (sec === "all" || sec == 8) {
      this.loadBucket(
        8,
        "my_vonboard_bfiles",
        '{"name":"vob_archived","op":"==","val":1},{"name":"onboarding_id","op":"==","val":"' +
        user.id +
        '"},{"name":"vob_attempted","op":"==","val":1}',
        page
      );
    }
  };
  loadCalendar = (ind) => {
    this.setState((prevState) => {
      const newBuckets = prevState.buckets.map((bucket, i) =>
        i === ind ? { ...bucket, loading: true } : bucket
      );
      return { buckets: newBuckets };
    }, () => {
      axios.get("/api/user_calendar_invite").then((res) => {
        this.setState((prevState) => {
          const updatedBuckets = prevState.buckets.map((bucket, i) =>
            i === ind ? { ...bucket, calls: res.data, loading: false } : bucket
          );
          return { buckets: updatedBuckets };
        });
      });
    });
  };
  loadBucket = (ind, api, filters, page) => {
    const { user, period, start_date, end_date, agency_id } = this.state;

    // Update loading state using callback
    this.setState((prevState) => {
      const newBuckets = prevState.buckets.map((bucket) =>
        bucket.index === ind ? { ...bucket, loading: true } : bucket
      );
      return { buckets: newBuckets };
    }, () => {
      const today = new Date();
      let from = new Date(today.getFullYear(), today.getMonth(), 1);
      let to = new Date(today.getFullYear(), today.getMonth() + 1, 1);

      if (period === "from_to") {
        from = moment(start_date).utc().format("YYYY-MM-DD");
        to = moment(end_date).utc().format("YYYY-MM-DD");
      } else {
        from = moment(from).utc().format("YYYY-MM-DD");
        to = moment(to).utc().format("YYYY-MM-DD");
      }

      if (ind !== 1 && filters !== "") {
        filters += `,{"name":"created_on","op":">=","val":"${from} 00:00:00"},{"name":"created_on","op":"<=","val":"${to} 23:59:59"}`;
      }

      // Get filters from state using callback
      this.setState((prevState) => {
        const bucket = prevState.buckets.find(b => b.index === ind);
        const more_filters = bucket ? { ...bucket.filters } : {};

        if (agency_id) {
          more_filters.agency = agency_id;
        }

        let queries = null;
        if (typeof more_filters.search !== "undefined") {
          queries = this.buildSearchQueries(more_filters.search);
          filters += `,{"or":${JSON.stringify(queries)}}`;
        }

        if (more_filters.agency && more_filters.agency !== "") {
          filters += `,{"name":"agency_id","op":"==","val":${more_filters.agency}}`;
        }

        if (prevState.agency_id) {
          filters += `,{"name":"agency_id","op":"==","val":${prevState.agency_id}}`;
        }

        const url = this.buildUrl(api, page, filters, ind);
        this.makeApiCall(url, ind);
        return {};
      });
    });
  };

  buildSearchQueries = (search) => {
    const queries = [
      { name: "first_name", op: "like", val: encodeURIComponent(`%${search}%`) },
      { name: "last_name", op: "like", val: encodeURIComponent(`%${search}%`) },
      { name: "spouse_first_name", op: "like", val: encodeURIComponent(`%${search}%`) },
      { name: "spouse_last_name", op: "like", val: encodeURIComponent(`%${search}%`) },
      { name: "email", op: "like", val: encodeURIComponent(`%${search}%`) }
    ];

    search.split(" ").forEach(term => {
      if (term) {
        queries.push(
          { name: "first_name", op: "like", val: encodeURIComponent(`%${term}%`) },
          { name: "last_name", op: "like", val: encodeURIComponent(`%${term}%`) },
          { name: "spouse_first_name", op: "like", val: encodeURIComponent(`%${term}%`) },
          { name: "spouse_last_name", op: "like", val: encodeURIComponent(`%${term}%`) }
        );
      }
    });

    return queries;
  };

  buildUrl = (api, page, filters, ind) => {
    const orderDirection = [0, 2, 4].includes(ind) ? "asc" : "desc";
    if (filters !== "") {
      return `/api/${api}?page=${page}&q={"filters":[${filters}],"order_by":[{"field":"expiration_date","direction":"${orderDirection}"}]}`;
    }
    return `/api/${api}?page=${page}&q={"order_by":[{"field":"expiration_date","direction":"${orderDirection}"}]}`;
  };

  makeApiCall = (url, ind) => {
    axios.get(url).then((res) => {
      this.setState((prevState) => {
        const newBuckets = prevState.buckets.map((bucket) => {
          if (bucket.index === ind) {
            const data = res.data.objects.map((bfile, i) => ({
              key: i,
              name: <Link to={`/customer/${bfile.id}`}>{`${bfile.first_name} ${bfile.last_name}`}</Link>,
              phone: <a href={`tel:${F.phone_format(bfile.phone)}`}>{F.phone_format(bfile.phone)}</a>,
              agency: bfile.agency.name,
              type: F.replaceNewBFileText(bfile.status),
              status: F.bfile_status(bfile),
              due_date: F.bfile_due_date(bfile, this.state.user.default_date),
              call_attempts: F.getCallAttemptsFromBFileQuestionArray(bfile),
              who_created: `${bfile.user.first_name} ${bfile.user.last_name}`,
              action: this.getActionButton(ind, bfile)
            }));

            return {
              ...bucket,
              loading: false,
              page: res.data.page,
              calls: data,
              total_pages: res.data.total_pages
            };
          }
          return bucket;
        });
        return { buckets: newBuckets };
      });
    });
  };

  getActionButton = (ind, bfile) => {
    if (ind === 1 || ind === 4) {
      return (
        <Button
          type="primary"
          onClick={() => this.claim(ind, bfile.id, bfile.expiration_date)}
        >
          Claim B File
        </Button>
      );
    }
    if (ind === 2) {
      return (
        <Button.Group>
          <Button type="primary" onClick={() => this.view(bfile.id)}>View</Button>
          <Button onClick={() => this.archive(ind, bfile.id)}>Complete/Archive</Button>
        </Button.Group>
      );
    }
    return (
      <Button type="primary" onClick={() => this.view(bfile.id)}>View</Button>
    );
  };

  claim = (ind, bfile_id, expiration_date) => {
    this.setState((prevState) => {
      const newBuckets = prevState.buckets.map((bucket) => 
        bucket.index === ind ? { ...bucket, loading: true } : bucket
      );
      return { buckets: newBuckets };
    }, () => {
      axios
        .put("/api/b_file/" + bfile_id, {
          archive: 0,
          not_interested: 0,
          onboarding_id: this.state.user.id,
          expiration_date: expiration_date,
          vo_claim_date: moment(new Date())
            .utc()
            .format("YYYY-MM-DD HH:mm:ss"),
        })
        .then(() => {
          this.props.history.push("/customer/" + bfile_id);
        });
    });
  };
  archive = (ind, bfile_id) => {
    this.setState((prevState) => {
      const newBuckets = prevState.buckets.map((bucket) => 
        bucket.index === ind ? { ...bucket, loading: true } : bucket
      );
      return { buckets: newBuckets };
    }, () => {
      axios
        .put("/api/b_file/" + bfile_id, {
          vob_archived: 1,
        })
        .then(() => {
          this.loadBuckets(ind, 1);
        });
    });
  };
  view = (bfile_id) => {
    this.props.history.push("/customer/" + bfile_id);
  };


  onSearchAgency = (index, value) => {
    this.setState((prevState) => {
      const newBuckets = prevState.buckets.map((bucket) => {
        if (bucket.index === index) {
          return {
            ...bucket,
            filters: {
              ...bucket.filters,
              search: value,
              agency: ""
            }
          };
        }
        return bucket;
      });
      return { buckets: newBuckets };
    }, () => {
      debounceQuery(() => this.search(index, value));
    });
  };

  render() {
    const {
      start_date,
      end_date,
      period,
      user,
      loading,
      buckets,
      columns,
      agencies,
      stats,
      stats_loading,
      agency_id,
    } = this.state;

    const dateFormat = "MM/DD/YYYY";

    let defaultFromDate = new Date(today.getFullYear(), today.getMonth(), 1);
    if (start_date) defaultFromDate = start_date;

    let defaultToDate = new Date(today.getFullYear(), today.getMonth() + 1, 1);
    if (end_date) defaultToDate = end_date;

    return (
      <div>
        <div className="topbar">
          <Card bordered={false}>
            <Row gutter={16} type="flex" justify="space-around" align="middle">
              <Col md={8} span={24}>
                <div className="username">
                  <Icon type="user" />
                  {user.first_name + " " + user.last_name}{" "}
                  <Tag color="blue">{user.user_type}</Tag>
                  <Switch
                    checked={this.props.view === "bonboard"}
                    onChange={(checked) =>
                      this.props.setView(checked ? "bonboard" : "review")
                    }
                    checkedChildren="BOB Calls"
                    unCheckedChildren="Review Scheduler"
                  />
                </div>
              </Col>
              <Col md={16} span={24}>
                <div
                  className="right-align"
                  style={{ marginTop: -5, marginBottom: -5 }}
                >
                  <div className="inlineField">
                    <Button icon="reload" onClick={this.refresh.bind(this)}>
                      {" "}
                      <Translate text={`Refresh`} />
                    </Button>
                  </div>
                  <div className="inlineField">
                    <Radio.Group
                      value={period}
                      onChange={this.changePeriod.bind(this)}
                      style={{ width: "100%" }}
                    >
                      <Radio.Button value="mtd">
                        <Translate text={`This Month`} />
                      </Radio.Button>
                      <Radio.Button value="from_to">
                        <Translate text={`All B Files`} />
                      </Radio.Button>
                    </Radio.Group>
                  </div>
                  <div className="inlineField">
                    {period !== "all_bfiles" ? (
                      <RangePicker
                        value={[moment(defaultFromDate), moment(defaultToDate)]}
                        onChange={this.onChangeDateRange}
                        format={dateFormat}
                        style={{ maxWidth: 200 }}
                      />
                    ) : null}
                  </div>
                </div>
              </Col>
            </Row>
          </Card>
        </div>
        <Spin indicator={antIcon} spinning={loading}>
          {buckets.map((bucket, i) => {
            if (bucket.title === "Calendar Invites") {
              return (
                <Card
                  key={i}
                  type="inner"
                  className="tableCard"
                  title={
                    <div style={{ paddingTop: 7 }}>
                      <Icon
                        type="folder"
                        style={{ marginRight: 10, color: "#1890ff" }}
                      />
                      {bucket.title}
                    </div>
                  }
                  loading={bucket.loading}
                  style={{ marginBottom: 20 }}
                >
                  <div style={{ padding: "25px" }}>
                    <Timeline>
                      {bucket.calls.map((item, i) => (
                        <Timeline.Item key={i}>
                          <div>
                            <Link
                              to={"/customer/" + item.bfile_id}
                              className="invite"
                            >
                              {item.customer_name}
                            </Link>
                          </div>
                          <div className="date">
                            <Translate text={`Date`} />:{" "}
                            {moment(new Date(item.date)).format(
                              "MM/DD/YYYY hh:mmA"
                            )}
                          </div>
                          <div className="agency">
                            <Translate text={`Agency`} />: {item.agency_name}
                          </div>
                        </Timeline.Item>
                      ))}
                      {bucket.calls.length === 0 ? (
                        <div className="notfound">
                          <Translate text={`No Invites Found`} />
                        </div>
                      ) : null}
                    </Timeline>
                  </div>
                </Card>
              );
            }

            return (
              <Card
                key={i}
                type="inner"
                className="tableCard"
                title={
                  <div style={{ paddingTop: 7 }}>
                    <Icon
                      type="folder"
                      style={{ marginRight: 10, color: "#1890ff" }}
                    />
                    {bucket.title}
                  </div>
                }
                loading={bucket.loading}
                style={{ marginBottom: 20 }}
                extra={
                  <Row
                    gutter={16}
                    style={{ maxWidth: 600 }}
                    type="flex"
                    justify="end"
                  >
                    <Col md={14} span={24}>
                      <Input
                        prefix={<Icon type="search" />}
                        onChange={(e) => this.onSearchAgency(bucket.index, e.target.value)}
                        value={bucket.filters.search}
                        placeholder="Search..."
                        onPressEnter={(e) => {
                          const searchPurify = F.removeSpecialCharactersFromString(
                            e.target.value
                          );

                          if (searchPurify.trim().length > 0) {
                            this.search(bucket.index, searchPurify);
                          }
                        }}
                      />
                    </Col>
                    {!agency_id ? (
                      <Col md={10} span={24}>
                        <Select
                          value={bucket.filters.agency}
                          style={{ width: "100%" }}
                          onChange={(val) => {
                            this.agencyChange(bucket.index, val);
                          }}
                        >
                          <Option value={""}>{"Filter by Agency"}</Option>
                          {agencies.map((agency, i) => (
                            <Option key={i} value={agency.id + ""}>
                              {agency.name}
                            </Option>
                          ))}
                        </Select>
                      </Col>
                    ) : null}
                  </Row>
                }
              >
                <Table
                  columns={columns}
                  dataSource={bucket.calls}
                  bordered={false}
                  pagination={false}
                  locale={{ emptyText: "No Data To Show" }}
                />
                {!bucket.loading ? (
                  <Pagination
                    current_page={bucket.page}
                    total_pages={bucket.total_pages}
                    onClick={(page) => {
                      this.loadBuckets(bucket.index, page);
                    }}
                  />
                ) : null}
              </Card>
            );
          })}
        </Spin>

        <Stats stats={stats} loading={stats_loading} />
      </div>
    );
  }
}

export default RSOVonboard;



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/rso-vonboard.js